import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { AccessTime } from "@mui/icons-material";

const TokenExpiredDialog = ({ open, onClose }) => {
  const [countdown, setCountdown] = useState(3);

  const clearSessionAndLogout = () => {
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = "/user/login";
  };

  useEffect(() => {
    if (open) {
      const timer = setInterval(() => {
        setCountdown((prevCountdown) => {
          if (prevCountdown === 1) {
            clearInterval(timer);
            onClose();
            clearSessionAndLogout();
          }
          return prevCountdown - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [open, onClose]);

  return (
    <Dialog open={open}>
      <DialogTitle className="session-expired-title">
        Session Expired
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText sx={{ color: "black", display: "flex" }}>
          <AccessTime color="error" sx={{ marginRight: "0.5rem" }} />
          Your session has expired due to inactiviy. Please login again.
        </DialogContentText>
        <DialogContentText sx={{ textAlign: "center", m: 4 }}>
          Redirecting to login in {countdown}...
        </DialogContentText>
        <DialogActions>
          <Button
            onClick={() => {
              onClose();
              clearSessionAndLogout();
            }}
            color="warning"
            variant="contained"
            fullWidth
            sx={{ margin: "0 auto" }}
          >
            Okay
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default TokenExpiredDialog;
